module.exports = __webpack_public_path__ + "static/media/abtimg2.7e92b7f7.png";